import { ProfileTypes } from '@/creditflowresearch/application/actions/profile/constants';
import { IgetFiltersByPairs, IMappingPairItem } from './types';

interface IsetSectorBlockFilters {
  pairs: string[],
  filters: IMappingPairItem,
  profileType: IgetFiltersByPairs['profileType'],
  mapping: IgetFiltersByPairs['mapping'],
}

export const setSectorBlockFilters = ({
  profileType,
  pairs,
  filters,
  mapping,
}: IsetSectorBlockFilters): IMappingPairItem => {
  const modifiedFilters = { ...filters };
  if (profileType === ProfileTypes.INDUSTRY) {
    modifiedFilters.sectorBlock = false;
  } else {
    Object.keys(pairs)
      .forEach((key) => {
        let currentMap = mapping[pairs[key]];
        if (currentMap?.sectorBlock === false) {
          modifiedFilters.sectorBlock = false;
        }
      });
  }

  return modifiedFilters;
};
